import { createFileRoute, useSearch } from '@tanstack/react-router'
import { AccessView } from '../../../components/group-steering/ResourcesViews'

export const Route = createFileRoute('/$org/group/access')({
    component: AccessRoute,
})

function AccessRoute() {
    const { org } = Route.useParams()
    const search = useSearch({ from: '/$org/group' })
    return <AccessView org={org} period={search.period ?? '90d'} level={search.level ?? 'agency'} />
}
